var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xF4\x80\x88\x8A",
    d: "M2.93703 13.6311L0.830232 14.4322C0.684936 14.4862 0.547712 14.4511 0.41856 14.327C0.294789 14.2084 0.262501 14.0681 0.321696 13.9063L1.14504 11.8347L10.6862 2.26181L12.4781 4.06633L2.93703 13.6311ZM13.358 3.1843L11.5579 1.38787L12.5346 0.416821C12.7714 0.184849 13.019 0.0607712 13.2773 0.0445872C13.541 0.0284031 13.7831 0.1336 14.0037 0.360177L14.3912 0.748595C14.6118 0.975172 14.7168 1.21793 14.706 1.47688C14.6952 1.73043 14.5715 1.97859 14.3347 2.22135L13.358 3.1843Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.dfa885e72ee9bd7103189f16df75a0cb.svg";
export { ForwardRef as ReactComponent };